import ConversationItemParts from './schema/ConversationItemParts';
import ConversationReadingPaneNode from './schema/ConversationReadingPaneNode';
import MailStore from './schema/MailStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

const mailStoreData: MailStore = {
    conversationNodes: new ObservableMap<string, ConversationReadingPaneNode>({}),
    conversations: new ObservableMap<string, ConversationItemParts>({}),
    items: new ObservableMap({}),
    searchFolderDisplayName: null,
    typeOfItemBeingDragged: null,
};

export let getStore = createStore<MailStore>('mail', mailStoreData);
const store = getStore();
export default store;
